/**
 * Asynchronously loads the component for AdminImportJobs
 */

import { lazyLoad } from "utils/loadable";

export const AdminImportJobs = lazyLoad(
  () => import("./index"),
  (module) => module.AdminImportJobs
);
